<template>
    <transition name="cz3__fade">
        <modal-wrapper
            :is-open="isQuitConfirmationModalOpen"
            @close="closeModal"
        >
            <focus-lock>
                <modal-content>
                    <modal-header @close="closeModal">
                        {{ $t('QUIT') }}
                    </modal-header>
                    <modal-body>
                        {{ $t('QUIT_CONFIRMATION_MODAL_COPY') }}
                    </modal-body>
                    <modal-footer>
                        <button
                            @click="closeModal"
                            class="
                              flex-1 w-full bg-gray-200 uppercase focus-outline-only focus-outline-only

                              lg:rounded-[4px]

                              text-gray-darker py-[16px] font-bold border border-gray-200
                            "
                        >
                            {{ $t('GO_BACK') }}
                        </button>
                        <button
                            @click="confirmQuit"
                            class="
                              flex-1 w-full uppercase text-white focus-outline-only

                              lg:rounded-[4px]

                              py-[16px] bg-orange focus-outline-only
                            "
                        >
                            {{ $t('QUIT') }}
                        </button>
                    </modal-footer>
                </modal-content>
            </focus-lock>
        </modal-wrapper>
    </transition>
</template>

<script>
    import FocusLock from 'vue-focus-lock';

    import allStores from '../../stores/all';

    import ModalWrapper from '../UI/modals/ModalWrapper.vue';
    import ModalContent from '../UI/modals/ModalContent.vue';
    import ModalHeader from '../UI/modals/ModalHeader.vue';
    import ModalBody from '../UI/modals/ModalBody.vue';
    import ModalFooter from '../UI/modals/ModalFooter.vue';

    export default {
        components: {
            FocusLock,
            ModalWrapper,
            ModalContent,
            ModalHeader,
            ModalBody,
            ModalFooter,
        },

        mixins: [allStores],

        computed: {
            isQuitConfirmationModalOpen() {
                return this.customizerStore.isQuitConfirmationModalOpen;
            },
        },

        methods: {
            closeModal() {
                this.customizerStore.closeQuitConfirmationModal();
            },

            confirmQuit() {
                this.customizerStore.confirmQuit();
            },
        },
    };
</script>
